import React, { Fragment } from 'react';
import Img from '../../../../../../components/Img';
import likeBtn from '../../../../../../static/images/common/like-btn.png';
import { setNumberWithComma } from '../../../../../../lib/common';
import Slider from '../../../../../../components/utils/Slider/Slider';
import './WidgetPreviewProductItem.scss';

const WidgetPreviewProductItem = (props) => {
  const { productItem, unnecessaryBrandNameAndLikeButton = false, isLike = true } = props;
  const { urlList, url, brandName, productName, discountRate, salesPrice } = productItem;

  return (
    <div className="widget-product-item">
      {urlList && urlList.length ? (
        <Slider
          className="widget-product-item-img-slider"
          list={urlList}
          arrows={false}
          item={(url) => <Img clickAble={false} src={url} />}
        />
      ) : (
        <Img clickAble={false} src={url} />
      )}

      <div className="product-info">
        {!unnecessaryBrandNameAndLikeButton ? (
          <div className="brand-name-and-like-btn-area">
            <div className="brand-name">{brandName}</div>

            {isLike && <Img className="like-btn" clickAble={false} src={likeBtn} />}
          </div>
        ) : null}

        <div className="product-name">{productName}</div>

        <div className="product-price-info">
          <span className="discount-price">
            {discountRate ? (
              <Fragment>
                {setNumberWithComma(discountRate)}
                <span className="unit">%</span>
              </Fragment>
            ) : null}
          </span>
          <span className="sales-price">
            {setNumberWithComma(salesPrice)}
            <span className="unit">원</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default WidgetPreviewProductItem;
